import React, { useEffect } from "react";
import TagManager from "react-gtm-module";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ApolloProvider } from "@apollo/react-hooks";
import { Redirect } from "react-router-dom";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.css";
import fetch from "isomorphic-unfetch";

import { Provider } from "react-redux";

import logo from "../../assets/white-logo.svg";
import createStore from "../../store";
import "./index.less";

import Audio from "../../components/Audio";
import { getUser } from "./../../lib/session";
import apollo from "./../../lib/apollo";
import PageContainer from "./../../containers/PageContainer";

// Polyfill fetch() on the server (used by apollo-client)
if (typeof window === "undefined") {
  global.fetch = fetch;
}

export default () => {
  const store = createStore();
  const introVariants = {
    visible: { opacity: 1, background: "#000" },
    hidden: { opacity: 0, background: "transparent" },
    animate: {
      opacity: 0,
      background: "transparent",
      transitionEnd: {
        display: "none"
      }
    }
  };

  const bgVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
    animate: {
      opacity: 0,
      transitionEnd: {
        display: "none"
      }
    }
  };

  const backgroundImages = [
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/11/2019/08/15190655/sea-418742_1920-768x576.jpg",
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/11/2019/08/15190653/ulsan-442399_1920-768x512.jpg",
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/11/2019/08/15190730/uVOzJn-w-768x494.jpeg",
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/11/2019/08/15190706/mountains-2535791_1920-768x307.jpg",
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/11/2019/08/15190726/lake-1030810_1920-768x512.jpg",
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/11/2019/08/15190724/lake-2535706-1-768x261.jpg",
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/11/2019/08/15190715/landscape-4110108-768x382.jpg",
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/11/2019/08/15190710/mountains-2532825-768x235.jpg",
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/11/2019/08/15190705/napali-coast-91676_1920-768x576.jpg"
  ];

  const index = Math.floor(Math.random() * Math.floor(backgroundImages.length));
  const currentBackground = backgroundImages[index];

  useEffect(() => {
    if (process.env.REACT_APP_TAGMANAGER) {
      const { username, type } = getUser() || {};
      TagManager.initialize({
        gtmId: process.env.REACT_APP_TAGMANAGER,
        auth: process.env.REACT_APP_TAGMANAGER_AUTH,
        preview: process.env.REACT_APP_TAGMANAGER_ENV,
        dataLayer: {
          userId: username || "guest",
          userProject: type || "login"
        }
      });
    }
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Audio>
          <Route
            render={({ location }) => (
              <>
                <motion.div
                  initial="visible"
                  animate="animate"
                  className="intro"
                  transition={{
                    ease: "easeOut",
                    delay: 3,
                    duration: 1
                  }}
                  variants={introVariants}
                >
                  <img
                    className="intro-logo"
                    src={logo}
                    width="200"
                    height="200"
                    alt="logo"
                  />
                </motion.div>
                <motion.div
                  initial="visible"
                  animate="animate"
                  className="mainbg"
                  transition={{
                    ease: "easeOut",
                    delay: 4,
                    duration: 2
                  }}
                  variants={bgVariants}
                  style={{ backgroundImage: `url(${currentBackground})` }}
                />
                <Switch location={location}>
                  <ApolloProvider client={apollo()}>
                    <PageContainer currentBackground={currentBackground} />
                  </ApolloProvider>
                </Switch>
              </>
            )}
          />
        </Audio>
      </BrowserRouter>
    </Provider>
  );
};
